import classnames from 'classnames';
import Icon from '../assets/file.svg';
import DeleteIcon from '../assets/delete.svg';
import { getFileSize } from '../utils';
import s from './index.module.scss';

export const FilePreview = ({ name, size, onRemove }) => {
  return (
    <div className={s.wrapper}>
      <div className={s.icon}>
        <img src={Icon} width={40} height={40} alt="file" />
      </div>
      <div className={s.content}>
        <div className={classnames('f-small-accent', s.name)}>{name}</div>
        <div className={classnames('f-small-regular', s.extension)}>
          {getFileSize(size)}
        </div>
      </div>
      <button type="button" className={s.btn_delete} onClick={onRemove}>
        <img src={DeleteIcon} width={20} height={20} alt="delete" />
      </button>
    </div>
  );
};
